import { render } from "./First.vue?vue&type=template&id=f36cdd1a"
import script from "./First.vue?vue&type=script&lang=js"
export * from "./First.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\work\\mecanografia1hora.com\\online_tecleando\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__